const let_5 = [
    "skunk",
    "smelt",
    "taste",
    "dashi",
    "heart",
    "layer",
    "licor",
    "cocoa",
    "icing",
    "grain",
    "smoky",
    "knife",
    "bread",
    "board",
    "yucca",
    "strip",
    "syrup",
    "pasta",
    "nashi",
    "tabil",
    "pisco",
    "cepes",
    "bison",
    "spoon",
    "shoyu",
    "spicy",
    "swede",
    "tripe",
    "steam",
    "agave",
    "kaong",
    "koshi",
    "baste",
    "horno",
    "tasso",
    "aioli",
    "speck",
    "craft",
    "picks",
    "pulse",
    "skirt",
    "scald",
    "dices",
    "spilt",
    "greek",
    "known",
    "style",
    "wedge",
    "scrub",
    "poach",
    "ajvar",
    "sheet",
    "spray",
    "smoke",
    "dress",
    "goose",
    "pitia",
    "comal",
    "chill",
    "shark",
    "snail",
    "crust",
    "mound",
    "liner",
    "mache",
    "mould",
    "gourd",
    "quail",
    "pimms",
    "salad",
    "pecan",
    "dough",
    "copha",
    "kashk",
    "pilaf",
    "swiss",
    "vodka",
    "snook",
    "cream",
    "latte",
    "trout",
    "chili",
    "ackee",
    "patis",
    "olive",
    "plate",
    "prune",
    "penne",
    "snoek",
    "salsa",
    "myoga",
    "smear",
    "candy",
    "blitz",
    "chard",
    "fudge",
    "capon",
    "wheat",
    "kefir",
    "mango",
    "sumac",
    "crepe",
    "basil",
    "panko",
    "frost",
    "cover",
    "torta",
    "glaze",
    "crumb",
    "squid",
    "chive",
    "quark",
    "curry",
    "juice",
    "crush",
    "chile",
    "puree",
    "bugle",
    "sugar",
    "broth",
    "cidar",
    "poppy",
    "perch",
    "flake",
    "slash",
    "grape",
    "shell",
    "shake",
    "shred",
    "clove",
    "kucai",
    "moose",
    "petal",
    "melon",
    "wraps",
    "grana",
    "morel",
    "jelly",
    "broil",
    "farro",
    "stuff",
    "cutup",
    "lemon",
    "sushi",
    "pizza",
    "ladle",
    "prawn",
    "mixer",
    "sieve",
    "matzo",
    "gravy",
    "roast",
    "blend",
    "okara",
    "flour",
    "peach",
    "stove",
    "sumaq",
    "brine",
    "steak",
    "kombu",
    "cumin",
    "thyme",
    "sopes",
    "slice",
    "latik",
    "acron",
    "blade",
    "colby",
    "grind",
    "creme",
    "anise",
    "swirl",
    "pesto",
    "grate",
    "saute",
    "honey",
    "serve",
    "crema",
    "chunk",
    "bamba",
    "stack",
    "spice",
    "bacon",
    "khubz",
    "corer",
    "roqaq",
    "konbu",
    "apple",
    "fryer",
    "kasha",
    "gyoza",
    "berry",
    "stock",
    "whirl",
    "recao",
    "crimp",
    "ranch",
    "squad",
    "knead",
    "crave",
    "onion",
    "prick",
    "sauce",
    "drink",
    "bagel",
    "fruit",
    "water",
    "basin",
    "scoop",
    "fries",
    "scone",
    "punch",
    "kokum",
    "smash",
    "moist",
    "whisk",
    "cajun",
    "mince",
    "chuck",
    "mirin",
    "kraft",
    "caper",
    "lardo",
    "dulse",
    "toast",
    "conch",
    "guava",
    "coppa",
    "dukka",
    "Glass",
    "tosss",
    "liver",
    "whips",
    "rises",
    "flips",
    "rolls",
    "pulls",
    "pipis",
    "seals",
    "Forks",
    "Foils",
    "turns",
    "snaps",
    "cools",
    "trims",
    "rests",
    "fills",
    "drops",
    "melds",
    "tongs",
    "discs",
    "slits",
    "melts",
    "foams",
    "peels",
    "wilts",
    "boils",
    "burns",
    "folds",
    "thaws",
    "mixes",
    "Trays",
    "Dries",
    "ovens",
    "packs",
    "beats",
    "wipes",
    "cooks",
    "chars",
    "tucks",
    "chops",
    "coats",
    "skins",
    "heats",
    "bowls",
    "stirs",
    "stews",
    "soaks",
    "rotis",
    "korma",
    "pista",
    "saunf",
    "lauki",
    "achar",
    "palak",
    "halva",
    "raita",
    "chana",
    "bundi",
    "jeera",
    "heeng",
    "panir",
    "maida",
    "khoya",
    "nadru",
    "besan",
    "tarka",

];

export default let_5;
